import validator from "validator";
import message from "../../../messages/ticket";

const validateText = (text) => {
  if (validator.isEmpty(text)) {
    return message.ADD_TICKET_TEXT_DOSE_NOT_EXIST;
  }

  if (!text.trim().length) {
    return message.ADD_TICKET_TEXT_DOSE_NOT_EXIST;
  }

  return true;
};

const validtionAnswerTicket = (data) => {
  const resValidateText = validateText(data.text);
  if (resValidateText != true) {
    return resValidateText;
  }

  return true;
};

export default validtionAnswerTicket;
